package uz.ferro.erp.feature.product.model

import kotlinx.serialization.Serializable
import uz.ferro.erp.feature.property.model.Property

@Serializable
data class ProductProperty(
    val id: Long? = null,
    val product: Product? = null,
    val property: Property? = null,
    val sort: Int? = null
)